import AddBoxIcon from "@mui/icons-material/AddBox";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import FolderIcon from "@mui/icons-material/Folder";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    Paper,
    TextField,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { Formik } from "formik";
import { useState } from "react";
import CheckboxTree from "react-checkbox-tree";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import DefaultApiService from "../../../../../infrastructure/api/default";
import { wrapFormikHandleChange } from "../../../../../infrastructure/utils/formatters";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("لطفا این فیلد را پر کنید."),
  isActive: Yup.bool(),
});

export const treeIcons = {
  check: <CheckBoxIcon color="primary" />,
  uncheck: <CheckBoxOutlineBlankIcon color="gray" />,
  halfCheck: <IndeterminateCheckBoxIcon color="info" />,
  expandClose: <ChevronLeftIcon color="black" />,
  expandOpen: <KeyboardArrowDownIcon color="black" />,
  expandAll: <AddBoxIcon color="primary" />,
  collapseAll: <IndeterminateCheckBoxIcon color="info" />,
  parentClose: <FolderIcon color="gray" />,
  parentOpen: <FolderOpenIcon color="gray" />,
  leaf: <InsertDriveFileIcon color="gray" />,
};

const onMakePermissionNodes = (nodes, roleId) => {
  if (Array.isArray(nodes)) {
    let checked = [],
      expanded = [];

    const array = nodes.map((node) => {
      const newNode = {
        value: node.id,
        label: node.title,
      };

      if (node.level === 3 || (node.level === 2 && node.link)) {
        if (node?.access) {
          checked.push(node.id);
          expanded.push(node.id);
        }
      } else {
        const {
          nodes: children,
          checked: newChecked,
          expanded: newExpanded,
        } = onMakePermissionNodes(node.child, roleId);

        newNode.children = children;
        checked = [...checked, ...newChecked];
        expanded = [...expanded, ...newExpanded];

        if (newExpanded.length > 0) {
          expanded.push(node.id);
        }
      }

      return newNode;
    });

    return { nodes: array, checked, expanded };
  }
};

const onFindNodeItem = (nodes, key) => {
  if (key) {
    let i,
      result = null;

    for (i = 0; result == null && i < nodes.length; i++) {
      if (nodes[i].value === key) {
        result = nodes[i];
      } else if (nodes[i].children) {
        result = onFindNodeItem(nodes[i].children, key);
      }
    }
    return result;
  }
};

const CustomerModulesModifyPage = () => {
  const roleInfoDetail = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);
  const [state, setState] = useState(
    onMakePermissionNodes(roleInfoDetail.permission, roleId)
  );

  // ***************** [ Tree Functions ] *****************
  const onCheckTreeItem = (checked) => {
    setState((old) => ({ ...old, checked }));
  };

  const onExpandTreeParent = (expanded) => {
    setState((old) => ({ ...old, expanded }));
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const data = {
      pmsCustomer: { ...roleInfoDetail.pmsCustomer, ...formValue },
      permission: [],
    };

    let permissions = [];
    for (let i = 0; i < state.checked.length; i++) {
      const selected = state.checked[i];
      // const [mode, key] = selected.split("-");
      const key = selected;
      const foundNode = onFindNodeItem(state.nodes, key);

      if (foundNode) {
        permissions.push({
          roleId: roleId !== "create" ? roleId : null,
          locationId: foundNode.value,
        });
      }
    }
    data.permission = permissions;
    try {
      console.log(data);
      const res = await DefaultApiService.modifyApi(
        "MNG/Customer/CustomerModules",
        data
      );

      if (res.isSuccess) {
        toast.success(res.message);
        navigate("/MNG/Customer/CustomerModules");
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error("خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={
              roleId !== "create"
                ? `ویرایش ${roleInfoDetail.pmsCustomer.firstName}`
                : "ایجاد"
            }
          />

          <CardContent>
            <Formik
              initialValues={roleInfoDetail.pmsCustomer}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                const onMakeFormikVariable = (name) => ({
                  name: name,
                  fullWidth: true,
                  value: values[name],
                  error: errors[name] && touched[name],
                  helperText: errors[name] && touched[name] && errors[name],
                  variant: "outlined",
                });

                return (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6} lg={4}>
                        <TextField
                          label="عنوان"
                          type="string"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("firstName")}
                        />
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <Paper elevation={3} sx={{ p: 2 }}>
                          <Box sx={{ mb: 1 }}>
                            <Typography variant="title" fontWeight={"bold"}>
                              دسترسی‌ها
                            </Typography>
                          </Box>
                          <Box>
                            <CheckboxTree
                              nodes={state.nodes}
                              checked={state.checked}
                              expanded={state.expanded}
                              onCheck={onCheckTreeItem}
                              onExpand={onExpandTreeParent}
                              icons={treeIcons}
                              showExpandAll
                            />
                          </Box>
                        </Paper>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        container
                        justifyContent={"flex-end"}
                      >
                        <Button
                          disabled={isSubmitting}
                          variant="outlined"
                          size="large"
                          color="gray"
                          sx={{ mx: 1 }}
                          onClick={() => {
                            navigate("/UM/Yeksa/CustomerModules");
                          }}
                        >
                          انصراف
                        </Button>

                        <Button
                          disabled={isSubmitting}
                          variant="contained"
                          type="submit"
                          size="large"
                        >
                          {loading && (
                            <CircularProgress size={16} color="inherit" />
                          )}
                          {roleId !== "create" ? "ویرایش" : "ایجاد"}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                );
              }}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CustomerModulesModifyPage;
